export default __webpack_public_path__ + "static/media/8theresalottounpack.091e2a5b.png";